import React from "react";
import TimberClassListItem from "../../components/timberClass/TimberClassList/TimberClassListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const TimberClassListPage = ()  => {

    useTitle(t`List Timber Class`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <TimberClassListItem showAdd={true} {...query} />
        </Box>
    )
}

export default TimberClassListPage;
